/** Beneficiary Id Number */
export const BENE_ID_NUMBER_MINLENGTH = 1;
export const BENE_ID_NUMBER_MAXLENGTH = 20;
export const BENE_PATTERN = /^[a-zA-Z0-9\-]+$/;

/** Mutual Funds UNITS Number */
export const UNITS_MINLENGTH = 1;
export const UNITS_MAXLENGTH = 20;
export const UNITS_PATTERN = /^[0-9]+$/;


/** Account Number */
export const ACCOUNT_NUMBER_MINLENGTH = 12;
export const ACCOUNT_NUMBER_MAXLENGTH = 12;
// export const ACCOUNT_NUMBER_PATTERN = /^[0-9]+$/;
export const ACCOUNT_NUMBER_PATTERN = /^(?!0+$)\d{9,}$/;



// export const ACCOUNT_NUMBER_MINLENGTH = 13;
// export const ACCOUNT_NUMBER_MAXLENGTH = 13;
// export const ACCOUNT_NUMBER_PATTERN = /^([0-9]\\d*|0)$/;

/** Amount  */
export const AMOUNT_DECIMAL_SEPERATOR = '.';
export const AMOUNT_INTEGER_VALUE = '0';
export const AMOUNT_DECIMAL_VALUE = '.00';
export const AMOUNT_DEFAULT_CURRENCY = 'EGP';
export const AMOUNT_ERROR_WARNING = 'Insufficient balance';

/** Beneficiary Name */
export const BENE_NAME_MINLENGTH = 3;
export const BENE_NAME_MAXLENGTH = 32;
export const BENE_NAME_PATTERN = /^[a-zA-Z ]+$/;

/** Bank Name and  Branch Name  */
export const BANK_BRANCH_NAME_MINLENGTH = 3;
export const BANK_BRANCH_NAME_MAXLENGTH = 50;
export const BANK_BRANCH_NAME_PATTERN =
  /^[A-Za-z\u0621-\u064A\u0660-\u0669 ]+$/;

/** Date  */
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};
export const DATE_FORMAT = 'DD/MM/YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const FILTER_API_DATE_FORMAT = 'DD-MM-YYYY';


/** Narative */
export const CONTROL_MAX_LENGTH = 110;

/** Remarks  */
export const REMARKS_MINLENGTH = 3;
export const REMARKS_MAXLENGTH = 100;
export const REMARKS_REGEX = /[A-Za-z0-9\u0621-\u064A\u0660-\u0669 .,_-]+$/;
export const REMARKS_ROWS = 5;
export const REMARKS_COLUMN = 40;
export const REMARKS_TYPE = 'singleline';
// export const BENE_ID_NUMBER_MINLENGTH = 20 ;

export const REFERENCE_KEY = 'referenceKey';
export const ADDITIONAL_DETAILS = 'additionalDetails';
export const REQUESTREFERENCE = 'requestReference';

export const ACCOUNTNAME_REGEX= /[A-Za-z]+$/
export const ACCOUNTNAME_MAXLENGTH=10;
export const ACCOUNTNAME_MINLENGTH=3;

/* Credit card number field */
export const CC_NUMBER_MINLENGTH = 16;
export const CC_NUMBER_MAXLENGTH = 16;
export const CC_NUMBER_REGEX = /[0-9]/;

// activity name
export const ACTIVITYNAME_REGEX= /^[A-Za-z0-9\u0621-\u064A\u0660-\u0669 -_]+$/
export const ACTIVITYNAME_MAXLENGTH=50;
export const ACTIVITYNAME_MINLENGTH=3;


/* dialog const */
export const OK_LABEL = "Ok";
export const CANCEL_LABEL = "Cancel";

export const YES_LABEL = "Yes";
export const NO_LABEL = "No";

/* customer name */
export const COUSTOMERID_REGEX= '^[0-9\.\-\/]+$'
export const COUSTOMERID_MAXLENGTH = 10;
export const COUSTOMERID_MINLENGTH = 1; 

/* password */
export const PASSWORD_MINLENGTH = 10;
export const PASSWORD_MAXLENGTH = 32;
// export const PASSWORD_REGEX =
//   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&])[A-Za-z\d#@$!%*?&]{10,32}$/;
// export const PASSWORD_REGEX = /^[A-Za-z0-9\d#@$!%*?&]{10,32}$/;
export const PASSWORD_REGEX = /^[A-Za-z0-9!$#^@&%*]{5,32}$/;

/* User name */
export const USERNAME_MINLENGTH = 8;
export const USERNAME_MAXLENGTH = 32;
export const USERNAME_REGEX= /^[a-zA-Z0-9\-]{8,32}$/;
export const USERNAME_REGEX_COB = /^[a-zA-Z0-9]{8,32}$/;
/* customer name */
export const COUSTOMERNAME_REGEX = /[A-Za-z\u0621-\u064A\u0660-\u0669 ]+$/
export const COUSTOMERNAME_MAXLENGTH = 30;
export const COUSTOMERNAME_MINLENGTH = 2;

export const CARD_HOLDER_NAME_REGEX=/[A-Za-z\u0621-\u064A\u0660-\u0669 ]+$/;
export const CARD_HOLDER_NAME_MAXLENGTH = 50;
export const CARD_HOLDER_NAME_MINLENGTH = 3;

/* Installment count */
export const INSTALLMENT_COUNT_REGEX= /[0-9]+$/
export const INSTALLMENT_COUNT_MAXLENGTH = 3;
export const INSTALLMENT_COUNT_MINLENGTH = 1;

export const EMAIL_REGEX=/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

/* Payment method */
export const REQUESTTYPE = 'requestType';
export const PAYMENTTYPE = 'paymentType';
export const BENEID = 'beneId';
export const MODE = 'mode';
export const ALLOWSCHEDULETRANSFER = 'allowScheduleTransfer';

export const NO_OFINSTALLMENT_PATTERN = /[0-9]/

// Iban-num
// export const IBANNUM_REGEX = /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/
export const IBANNUM_MAXLENGTH = 29;
export const IBANNUM_MINLENGTH = 29;
export const IBANNUM_MAXLENGTH_INT = 34;
export const IBANNUM_MINLENGTH_INT = 18;
// export const IBANNUM_REGEX = /[A-Za-z0-9]+$/
export const IBANNUM_REGEX = /^[A-Za-z]{2}[0-9]{2}[A-Za-z0-9]{4}[0-9]{4}[0-9]{17}$/
export const IBANNUM_REGEX_INT = /^[A-Za-z]{2}[A-Za-z0-9]{16,32}$/

/* Mobile number */
export const MOBILE_NUMBER_MINLENGTH = 7;
export const MOBILE_NUMBER_MAXLENGTH = 8;
// export const MOBILE_NUMBER_PATTERN = /^[0-9]$/;
export const MOBILE_NUMBER_PATTERN = /^[0-9]{7,15}$/;
export const WHATSAPP_NUMBER_PATTERN = /^[0-9]{4,16}$/;
// export const MOBILE_NUMBER_PREFIX = "675-";
export const MOBILE_NUMBER_MASK = "0*";

export const DELETE_ACTION = "delete";

export const UPPERCASE = /[A-Z]/;
export const LOWERCASE = /[a-z]/;
// export const SPECIALCHARS = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
//export const SPECIALCHARS = /[!@#$%^&*]+/;
export const SPECIALCHARS = /^([a-zA-Z0-9@]{10,32})$/;

// !, $, #, ^ , @, &, %,*

export const ONLY_NUMARIC = /[0-9]/;


// MPIN
export const MPIN_MAXLENGTH=4;
export const MPIN_MINLENGTH=4;

// OTP
export const OTP_MAXLENGTH=6;
export const OTP_MINLENGTH=6;
export const OTP_EXPIRE_SEC=120;

/** Cheque Number */
export const CHEQUE_NUMBER_MINLENGTH = 5;
export const CHEQUE_NUMBER_MAXLENGTH = 20;
export const CHEQUE_NUMBER_PATTERN = /^[0-9]+$/;

/** DebitCard Number */
export const DEBIT_CARD_NUMBER_MINLENGTH = 8;
export const DEBIT_CARD_NUMBER_MAXLENGTH = 8;
export const DEBIT_CARD_NUMBER_PATTERN = /^[0-9]+$/;

/**Interest Rate */
export const INTEREST_RATE_PATTERN = /^[0-9]*.[0-9]*$/;

/** Tenure */
export const TENURE_MINLENGTH = 1;
export const TENURE_MAXLENGTH = 3;
export const TENURE_PATTERN = /^[0-9]+$/;

export const PINCODE_PATTERN = /^[0-9]{3,3}$/;

export const PID_NUMBER_PATTERN = /^[a-zA-Z0-9]$/;

export const SHOW_PIN_OPTION : boolean = false;

/** WITHIN BENEFICIARY */
export const WITHIN_BANK_ACCOUNT_NUMBER_MINLENGTH = '8';
export const WITHIN_BANK_ACCOUNT_NUMBER_MAXLENGTH = '8';

/** DOMESTIC BENEFICIARY */
export const DOMESTIC_BANK_ACCOUNT_NUMBER_MINLENGTH = '7';
export const DOMESTIC_BANK_ACCOUNT_NUMBER_MAXLENGTH = '20';
